"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Stepper = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)({
  root: {
    width: '100%',
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 0.15,
    textAlign: 'center'
  }
});
const Stepper = _ref => {
  let {
    activeStep,
    listLabels
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Stepper, {
    activeStep: activeStep,
    alternativeLabel: true,
    orientation: "horizontal"
  }, listLabels.map(label => /*#__PURE__*/_react.default.createElement(_core.Step, {
    key: label
  }, /*#__PURE__*/_react.default.createElement(_core.StepLabel, {
    className: classes.root
  }, label))));
};
exports.Stepper = Stepper;
Stepper.propTypes = {
  /**
   * Define a etapa ativa
   */
  activeStep: _propTypes.default.number.isRequired,
  /**
   * Lista dos rótulos de cada etapa
   */
  listLabels: _propTypes.default.arrayOf(_propTypes.default.string.isRequired)
};
Stepper.defaultProps = {
  listLabels: 0
};
var _default = exports.default = Stepper;